module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greek Yogurt Breakfast Bark")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 6–8 | Prep Time: 10 minutes plus 2 hours chill time | Cook Time: N/A")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("When I’m running late to work in the morning, I often just grab the nearest muffin or waffle and head out the door. Breakfast bark allows me to keep nibbling away at something as I try to find my purse and shoes, while still feeling good knowing that it’s full of good-for-you ingredients like fruit and nuts!")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1½ cups Greek yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 tablespoons maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon honey")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup mixed berry granola, such as Quaker Real Medleys Granola")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("6 strawberries, 3 sliced and 3 chopped")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup pistachios")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Line a 9 × 13-inch baking pan (or 8 × 8-inch baking pan if you want a thicker bark) with parchment paper, leaving an overhang on two sides.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. In a small bowl, combine the yogurt, maple syrup, and honey.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. Pour the mixture into the baking pan and spread it to about ¼ inch to ½ inch thick.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Sprinkle the granola, blueberries, strawberries (sliced and chopped), and pistachios over the yogurt mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Cover the baking pan with foil and place in the freezer for at least 2 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. Break or cut into pieces. Put on a platter and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "notehead"
  }, [_c('strong', [_vm._v("VARIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "NotebText"
  }, [_vm._v("Use different granola flavor combinations, fruits, and nuts. You can also add coconut and dark chocolate chips.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-093e3170","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect5.vue
// module id = 99
// module chunks = 0